import { ActionBar, ChakraBox, ChakraFlex } from '@equip.health/ui';
import Layout from '~/components/common/Layout';
import CareTeamHeader from './CareTeamHeaderV2';
import { CareTeamTranslations } from '~/lib/constants/careTeam.constants';

const TOP_LEVEL_ID = 'care-plan__care-team-v2-error-fallback';
const ITEM_WIDTH = 300;

const CareTeamErrorFallback = () => {
  return (
    <Layout minWidth={`${ITEM_WIDTH}px`} title={null} titleId={TOP_LEVEL_ID}>
      <ChakraFlex marginBottom="18px" width="100%">
        <CareTeamHeader
          count={0}
          id={`${TOP_LEVEL_ID}-header`}
          isDisabled
          isLoading={false}
          onEdit={() => {}}
        />
      </ChakraFlex>
      <ChakraBox>
        <ActionBar
          id="care-team-error-fallback"
          text={CareTeamTranslations.ERROR_LOADING_CARE_TEAM}
          textPlacement="center"
          variant="critical"
        />
      </ChakraBox>
    </Layout>
  );
};
export default CareTeamErrorFallback;
